import { selectize } from 'selectize';

(function () {

  // cookie

  function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  function setCookie(name, value, options = {}) {

    options = {
      path: '/',
      // при необходимости добавьте другие значения по умолчанию
      ...options
    };
  
    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }
  
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
  
    for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }
  
    document.cookie = updatedCookie;
  }

  const cookie = document.querySelector('.js-cookie')

  window.addEventListener('load', () => {

    if (cookie) {
  
      const switcher = cookie.querySelector('.js-cookie-switcher')
      const button = cookie.querySelector('.js-cookie-btn')
  
      console.log(getCookie('track'))
  
      if (getCookie('track')) {
  
        if (getCookie('track') === 'false') {
          switcher.classList.remove('active')
        }
  
        if (getCookie('track') === 'true') {
          switcher.classList.add('active')
        }
  
      } else {
        setCookie('track', 'true', { 'max-age': 3600 * 24 * 365 })
        setCookie('cookieModal', 'true', { 'max-age': 3600 * 24 * 365 })
        switcher.classList.add('active')
      }
  
      switcher.addEventListener('click', e => {
        e.preventDefault()
        switcher.classList.toggle('active')
        if (switcher.classList.contains('active')) {
          setCookie('track', 'true', { 'max-age': 3600 * 24 * 365 })
        } else {
          setCookie('track', 'false', { 'max-age': 3600 * 24 * 365 })
        }
      })
  
      button.addEventListener('click', e => {
        e.preventDefault()
        closeModal()
        setCookie('cookieModal', 'false', { 'max-age': 3600 * 24 * 365 })
      })
  
      if (getCookie('cookieModal') === 'true') {
        openModal('cookies-modal')
      }
  
    }
  })
  

  // selectize

  const dropdown = document.querySelectorAll('.js-selectize')

  if (dropdown.length) {
    dropdown.forEach(el => {
      $(el).selectize()
    })
  }

  // modals

  function openModal (id) {
    const modal = document.getElementById(id)

    if (modal) {
      document.body.classList.add('block-scroll')
      $(modal).fadeIn(300)
    }
  }

  function closeModal () {
    document.body.classList.remove('block-scroll')
    $('.js-modal').fadeOut(300)
  }

  const openBtn = document.querySelectorAll('.js-modal-open')
  const closeBtn = document.querySelectorAll('.js-modal-close')

  openBtn.forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault()
      closeModal()
      const id = el.getAttribute('data-modal-id')
      openModal(id)
    })
  })
  
  closeBtn.forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault()
      closeModal()
    })
  })

  // password toggle

  const passwordToggleIcons = document.querySelectorAll('.js-password-toggle')

  if (passwordToggleIcons.length) {
    passwordToggleIcons.forEach(el => {
      el.addEventListener('click', e => {
        const $input = $(el).prev('input')
        if (el.classList.contains('active')) {
          el.classList.remove('active')
          $input.attr('type', 'password')
        } else {
          el.classList.add('active')
          $input.attr('type', 'text')
        }
      })
    })
  }


})();